module.exports = __webpack_public_path__ + "img/bg_pic8.cb907e0d.png";